module.exports = __webpack_public_path__ + "static/img/img_hotsprot1.c96473d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_hotsprot1.jpg
// module id = 0sMk
// module chunks = 0